import {
    Box,
    Toolbar
} from "@mui/material";
import { useState } from "react";
import ApplicationLogo from "../../Components/ApplicationLogo";
import { useMicrospecDynamicUIContext } from "../../GlobalProvider";
import { useOrganizationContext } from "../OrganizationContext";
import OrganizationContextSelector from "../OrganizationContext/OrganizationContextSelector";
import { useMicrospecThemeLanguageContext } from "../../Themes";

const DrawerUpperContent = ({ data, isMobile }) => {
    const organizationContextAware = data.organizationContextAware;
    const [isHovered, setIsHovered] = useState(false);
    const { localizationProvider } = useMicrospecThemeLanguageContext();
    const { config } = useMicrospecDynamicUIContext();
    const { application } = config;
    const { name, dashboardsLogo } = application;
    const localizedApplicationName = localizationProvider.translateByType(name);
    // Get organization context - always call hook, check flag after
    const organizationContext = useOrganizationContext();

    return (
        <Toolbar
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                py: 3,
                px: 2,
                gap: 2,
                minHeight: 'auto',
                background: 'transparent',
                position: 'relative',
                overflow: 'hidden',
                '&::before': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: (theme) => theme.palette.mode === 'dark'
                        ? 'radial-gradient(circle at center, rgba(255, 255, 255, 0.03) 0%, transparent 70%)'
                        : 'radial-gradient(circle at center, rgba(0, 0, 0, 0.02) 0%, transparent 70%)',
                    pointerEvents: 'none',
                }
            }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Enhanced app section */}
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: "center",
                    gap: 2,
                    width: '100%',
                    transition: 'all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1)',
                    transform: isHovered ? 'scale(1.02)' : 'scale(1)',
                }}
            >
                {/* App logo with flexible container */}
                {
                    !isMobile && (
                        <ApplicationLogo
                            overrideDefaultLogo={dashboardsLogo}
                            height={organizationContextAware ? 40 : 60}
                        />
                    )
                }
                {/* Application name */}
                {isMobile && <Box
                    sx={{
                        fontSize: isMobile ? '0.9rem' : '1.2rem',
                        fontWeight: 600,
                        color: (theme) => theme.palette.mode === 'dark' ? '#f0f0f0' : 'primary.main',
                        textShadow: '0 2px 4px rgba(0,0,0,0.1)',
                        textAlign: 'center',
                    }}
                >
                    {localizedApplicationName}
                </Box>}
            </Box>
            {/* Organization Context Selector */}
            {organizationContextAware && organizationContext?.isOrganizationContextAware && (
                <Box sx={{
                    width: '100%',
                }}>
                    <OrganizationContextSelector compact={true} />
                </Box>
            )}
        </Toolbar>
    );
};

export default DrawerUpperContent;